export default function currencyFormat(number, { currency = 'USD', precision = 0, isShowCurrencyName = true } = {}) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: precision,
    currencyDisplay: 'narrowSymbol',
  });

  let numberString = formatter.format(number);
  if (currency === 'CHF') {
    numberString = numberString.replace('CHF', '₣');
  }

  return isShowCurrencyName ? `${numberString} ${currency}` : `${numberString}`;
}
